var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.store.toasts),function(t){return _c('Toast',{key:t.id,attrs:{"id":t.id,"variant":t.variant,"show":t.show}},[_vm._v(" "+_vm._s(t.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }